// @flow

import * as React from "react";

type Props = {
  children: React.Node,
};

const Row = (props: Props) => {
  const children = React.Children.toArray(props.children);

  // Filter out the actions from the rest of the children
  const nodes = [];
  let actions;
  children.forEach((child) => {
    if (child.type && child.type.displayName === "Panel.RowActions") {
      actions = child;
    } else {
      nodes.push(child);
    }
  });

  return (
    <div className="py2 px3 flex items-center">
      <div className="flex-auto">{nodes}</div>
      {actions}
    </div>
  );
};

Row.displayName = "Panel.Row";

export default Row;
